import styled from 'styled-components';

export const GridWrapper = styled.div`
    height: 80vh;
    width: 100%;
    overflow: visible;

    .ag-header-cell {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #133666;
        color: white;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        text-align: center;
        line-height: 28px;
    }

    .ag-cell-wrapper {
        justify-content: center;
    }

    .wrap-cell .ag-cell-wrapper {
        justify-content: flex-start;
    }

    .list-cell {
        text-align: center;
        line-height: 28px;
    }
`;
